import { Platform } from './Platform';
import { Response } from './Response';

/**
 * confirm_number_status
 * После ввода телефона и нажатия на кнопку "Далее" при получении ответа на метод старта /call/start трекать ошибку/успех
 */
export interface ConfirmNumberStatus {
  platform: Platform;

  response: Response;
}

export function mapConfirmNumberStatusEvent(event: ConfirmNumberStatus): object {
  const props: Record<string, unknown> = {
      platform: event.platform,
      response: event.response,
  };

  return {
    event: 'analytics_event',
    event_name: 'confirm_number_status',
    event_properties: Object.fromEntries(
      Object.entries(props)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => [k, String(v)])
    ),
  };
}
